import { render, staticRenderFns } from "./BoxLayout.vue?vue&type=template&id=335aa646&"
import script from "./BoxLayout.vue?vue&type=script&lang=js&"
export * from "./BoxLayout.vue?vue&type=script&lang=js&"
import style0 from "./BoxLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports